export default "__VITE_ASSET__aHOGQzV0__"